import React, { Suspense } from 'react';
import { AdminOrdersPage } from './AdminOrdersPage';

// Loading component específico para admin
const AdminLoading = () => (
  <div className="h-full w-full flex flex-col bg-navy-900 min-w-[285px]">
    <div className="p-4 border-b border-navy-800">
      <div className="animate-pulse flex items-center space-x-3">
        <div className="h-8 w-20 bg-navy-800 rounded"></div>
        <div className="h-6 w-18 bg-navy-800 rounded"></div>
      </div>
    </div>
    <div className="flex-1 p-4">
      <div className="animate-pulse space-y-3">
        <div className="h-8 w-full bg-navy-800 rounded"></div>
        <div className="h-6 w-2/3 bg-navy-800 rounded"></div>
        <div className="h-6 w-1/2 bg-navy-800 rounded"></div>
      </div>
    </div>
  </div>
);

// Componente lazy com fallback específico
export const AdminOrdersPageLazy = React.lazy(() =>
  import('./AdminOrdersPage').then(module => ({
    default: module.AdminOrdersPage
  }))
);

// Wrapper com Suspense e fallback específico
export const AdminOrdersPageWithSuspense: React.FC<{ onBack?: () => void }> = ({ onBack }) => (
  <Suspense fallback={<AdminLoading />}>
    <AdminOrdersPageLazy onBack={onBack} />
  </Suspense>
);
